import React from 'react';
import Localize from 'react-intl-universal';

import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

import StyledBoxCenter from '@components/StyledBoxCenter/StyledBoxCenter';
import StyledConfirmTypography from '@components/StyledConfirmTypography/StyledConfirmTypography';
import StyledErrorIcon from '@components/StyledErrorIcon/StyledErrorIcon';

const StyledContainer = styled(Container, {
  shouldForwardProp: (prop) => prop !== 'bookingNumberUuid'
})(({ bookingNumberUuid }) => ({
  minHeight: bookingNumberUuid ? 'calc(100vh - 8.4rem)' : 'calc(100vh - 5.4rem)'
}));

const EventNotAvailable = () => {
  return (
    <StyledContainer>
      <StyledBoxCenter>
        <StyledErrorIcon />
        <StyledConfirmTypography>
          {Localize.get('Booking.eventUnavailable')}
        </StyledConfirmTypography>
      </StyledBoxCenter>
    </StyledContainer>
  );
};

export default EventNotAvailable;
